<form [formGroup]="form()">
  @let controls = form().controls;
  <div class="group">
    <div class="option">
      <div class="index f-body-l">{{ index() + 1 }}</div>
    </div>

    <onyx-dropdown
      [formControl]="controls.type"
      label="labels.name"
      [hint]="`${I18N}.typeHint`"
      [options]="permissions()"
      [search]="true"
      [showAddOption]="true"
      (addOption)="addPermission($event)"
      [size]="32"
    ></onyx-dropdown>
  </div>

  <onyx-datepicker
    [formControl]="controls.expirationDate"
    label="labels.expirationDate"
    [yearsRange]="{ past: 0, future: 20 }"
    [warningTypes]="['pastDate']"
    [size]="32"
  ></onyx-datepicker>

  <div class="scans">
    <onyx-upload
      [formControl]="controls.scans"
      label="labels.permissionScan"
      [size]="32"
      [limit]="2"
    ></onyx-upload>

    <onyx-icon-button
      class="option"
      variant="transparent"
      color="black"
      [size]="32"
      icon="delete-outlined"
      (click)="remove.emit()"
    ></onyx-icon-button>
  </div>
</form>
